import React from "react";
import checkIcon from "../assets/check_circle.svg";

interface CheckedIndicatorProps {
  text?: string;
  className?: string;
}

const CheckedIndicator: React.FC<CheckedIndicatorProps> = ({
  text = "Checked",
  className = "",
}) => {
  return (
    <div
      className={`flex flex-row gap-2 bg-[#DBFFEA] items-center justify-center border border-[#1FD167] rounded-full pl-[10px] pr-[14px] py-1.5 ${className}`}
    >
      <div>
        <img src={checkIcon} alt="checked" className="w-[18px] h-[18px]" />
      </div>
      <div className="text-[#03963F] font-dm-sans text-[14px] font-medium leading-normal">
        {text}
      </div>
    </div>
  );
};

export default CheckedIndicator;
